import { restClient } from '@/Core'
import type { Chat } from '../Contracts'
import { mapApiChat, type ApiChat } from '../Helpers/apiMappers'

export type CreateChatParams =
    | { type: 'private'; participantId: string }
    | { type: 'group'; participantIds: string[]; name: string }

/**
 * Creates a chat (or, for private chats, returns the already existing one —
 * the backend deduplicates the pair and answers 200 instead of 201).
 * The creator is added as a participant by the backend automatically.
 */
export const CreateChatTask = async (params: CreateChatParams): Promise<Chat> => {
    const body =
        params.type === 'private'
            ? { type: 'private', participantIds: [params.participantId] }
            : { type: 'group', participantIds: params.participantIds, name: params.name }

    const response = (await restClient.post('/services/chat/chats', {
        json: body,
    })) as ApiChat | null

    return mapApiChat(response ?? {})
}
